import React from "react";
import { Flex, Skeleton as ChakraSkeleton } from "@chakra-ui/react";

const Skeleton: React.FC = () => {
  return (
    <Flex flexDirection="row" flexWrap="wrap" gap="12px">
      <ChakraSkeleton
        height={6}
        startColor="gray.200"
        endColor="gray.200"
        width="94px"
        borderRadius="6px"
      />
    </Flex>
  );
};

export default Skeleton;
